/* eslint-disable import/prefer-default-export */
import { formatDate } from '@/helpers';

export const localize = importList => ({
    id: importList.id,
    category : importList?.category,
    regulations: importList?.regulations,
    lastUpdated: formatDate(importList?.last_updated),
    status: importList?.status,
});